import {enStrings} from "./en";

export const languageStrings = {
    en: enStrings,
};

